import React, { useContext } from 'react';
import GaTracking from '../ga';

const GaTrackingContext = React.createContext<GaTracking>({} as GaTracking);

export const GaTrackingProvider = GaTrackingContext.Provider;

const useGa = () => {
    return useContext(GaTrackingContext);
};

export default useGa;
